import React from "react";
import P from "prop-types";

import { MapSession } from "./MapSession";
import { AreaChartSession } from "./AreaChartSession";
import { CBORankingSession } from "./CBORankingSession";

import * as Styles from "../styles";

export function Obitos({ hidden, queryState }) {
  if (hidden) {
    return <></>;
  } else {
    return (
      <Styles.Container>
        <MapSession />
        <AreaChartSession queryState={queryState} />
        <CBORankingSession queryState={queryState} />
      </Styles.Container>
    );
  }
}

Obitos.propTypes = {
  hidden: P.bool.isRequired,
  queryState: P.string.isRequired,
};
